import React, {createContext, useReducer} from 'react'
import {LEDControllerConfigurationReducer} from "../reducer/LEDControllerConfigurationReducer"

export const LEDControllerConfigurationContext = createContext();

const LEDControllerConfigurationContextProvider = (props) => {
    const data = {
        ledDevices: {},
        aisleTypes: new Set(),
        ledAisleData: [],
        ledControllerType: null,
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(LEDControllerConfigurationReducer, data)
    return (
        <LEDControllerConfigurationContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </LEDControllerConfigurationContext.Provider>
    )
}

export default LEDControllerConfigurationContextProvider


// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/context/LEDControllerConfigurationContext.js